import React, { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import TextArea from "../ReusableComponents/TextArea";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import { LaundryIssueHeader, roleMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import LaundryIssuePopup from "../popup-containers/LaundryIssuePopup"
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import usePrevious from "../Hook/UsePrevious";
import LaundryIssuesPopup from "../popup-containers/LaundryIssuesPopup";
import PopUpButtons from "../components/PopUpButtons";
import LaundryIssues from "../popup-containers/LaundryIssuesPopup";
import Loader from "../ReusableComponents/Loader";

const LaundryIssue = () => {

  const [visibleTable, setVisibleTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpOpen1, setpopUpOpen1] = useState(false);

  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const mstClientId = sessionStorage.getItem("MstClientId");
  const [txnLaundryIssuesId, setTxnLaundryIssuesId] = useState(0);

  const [bindLaundryIssue, setBindLaundryIssue] = useState([]);
  const [bindLaundryIssueChild, setBindLaundryIssueChild] = useState([]);


  const [laundryIssueDetails, setLaundryIssueDetails] = useState([]);
  const [bindLaundryCompanies, setBindLaundryCompanies] = useState([]);
  const [bindItemType, setBindItemType] = useState([]);
  const [bindItemCategory, setBindItemCategory] = useState([]);
  const [bindItem, setBindItem] = useState([]);

  const [viewPopupData, setViewPopupData] = useState([]);
  const [viewPopupChildData, setViewPopupChildData] = useState([]);
  const [viewPopupData1, setViewPopupData1] = useState([]);
  const [viewPopupChildData1, setViewPopupChildData1] = useState([]);



  const [laundryIssuesFields, setLaundryIssuesFields] = useState({
    issueNo: "LIS",
    date: new Date().toISOString().split("T")[0],
    issuedTo: "",
    issuedBy: "",
    remarks: "",
  });

  const [laundryIssuesFieldsError, setLaundryIssuesFieldsError] = useState({

    issuedToError: "",
    issuedByError: "",

  });
  const [laundryIssuesError, setLaundryIssuesError] = useState("");
  const [tableData, setTableData] = useState([
    {
      MstItemTypeId: "",
      MstItemcategoryId: "",
      MstItemId: "",
      UOM: "",
      Quantity: "",
      Rate: "",
      ItemcategoryList: [],
      ItemList: []
    },
  ]);
  const previousTableData = usePrevious(tableData);
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
  };





  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setLaundryIssueDetails(jsonString);
      console.log("data", tableData)

      console.log("JsonString", jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const handlePopup = (rowIndex, flag) => {

    setpopUpOpen1(true)
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    const rowData = bindLaundryIssue[rowIndex]

    const txnLaundryIssueId = bindLaundryIssue[rowIndex].TxnLaundryIssuesId;
    setTxnLaundryIssuesId(txnLaundryIssueId)
    const laundryIssueData = Object.values(bindLaundryIssueChild).filter(
      (item) => {
        return String(item.TxnLaundryIssuesId) === String(txnLaundryIssueId);
      }
    );


    setViewPopupData1(rowData)
    setViewPopupChildData1(laundryIssueData)
  };





  const handleAddRow = () => {
    setTableData([
      ...tableData,
      {
        MstItemTypeId: "",
        MstItemcategoryId: "",
        MstItemId: "",
        UOM: "",
        Quantity: "",
        Rate: "",
        ItemcategoryList: [],
        ItemList: []
      },
    ]);
  };

  const showView = (rowIndex, flag) => {

    setpopUpOpen(true)

    const rowData = bindLaundryIssue[rowIndex]

    const txnLaundryIssueId = bindLaundryIssue[rowIndex].TxnLaundryIssuesId;

    const laundryIssueData = Object.values(bindLaundryIssueChild).filter(
      (item) => {
        return String(item.TxnLaundryIssuesId) === String(txnLaundryIssueId);
      }
    );

    setViewPopupData(rowData)
    setViewPopupChildData(laundryIssueData)
  };

  // const handleDeleteRow = (index) => {
  //   if (tableData.length != 1) {
  //     const updated = [...tableData];
  //     updated.splice(index, 1);
  //     setTableData(updated);
  //   } else {
  //     setTableData([
  //       {
  //         MstItemTypeId: "",
  //         MstItemcategoryId: "",
  //         MstItemId: "",
  //         UOM: "",
  //         Quantity: "",
  //         Rate: "",
  //         ItemcategoryList: [],
  //         ItemList: []
  //       },
  //     ]);
  //   }
  // };

  const handleDeleteRow = (index) => {
    let updatedData = [];
  
    if (tableData.length > 1) {
      updatedData = tableData.filter((_, i) => i !== index);
    } else {
      updatedData = [
        {
          MstItemTypeId: "",
          MstItemcategoryId: "",
          MstItemId: "",
          UOM: "",
          Quantity: "",
          Rate: "",
          ItemcategoryList: [],
          ItemList: [],
        },
      ];
    }
  
    setTableData(updatedData);
    convertArrayToJSONString(updatedData); // ✅ CRITICAL
  };

  const cancel = async () => {
    setpopUpOpen(false);
    setpopUpOpen1(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setIsLoading(false);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setLaundryIssuesFields({
      issueNo: "LIS",
      date: new Date().toISOString().split("T")[0],
      issuedTo: "",
      issuedBy: "",
      remarks: "",
    });
    setLaundryIssuesFieldsError({

      issuedToError: "",
      issuedByError: "",
    });
    setLaundryIssuesError("");
    setTableData([
      {
        MstItemTypeId: "",
        MstItemcategoryId: "",
        MstItemId: "",
        UOM: "",
        Quantity: "",
        Rate: "",
        ItemcategoryList: [],
        ItemList: []
      },
    ]);
    setLaundryIssueDetails([])
    setViewPopupData([])
    setViewPopupChildData([])
    setViewPopupData1([])
    setViewPopupChildData1([])
    getLaundryIssueDatas();
    getLaundryCompaniesDatas();
    getItemTypeDatas();
    getItemCategoryDatas();
    getItemDatas();
  };

  const handleSubmit = async (items, flag) => {
    debugger;

    setSubmitBtnDisabled(true)
    setIsLoading(true);
    if (flag == 1 || flag == 2) {

      const isFormError = {
        ...laundryIssuesFieldsError,
        issuedToError: laundryIssuesFields.issuedTo > 0 ? "" : "Select Issued To",
        issuedByError: laundryIssuesFields.issuedBy?.trim()
          ? ""
          : "Enter Issued By",
      };
      let hasLaundryIssueErrors = false;
      if (laundryIssueDetails.length === 0) {
        setLaundryIssuesError("Fill the above table");
      } else {
        let laundryIssuesData = [];
        try {
          laundryIssuesData = JSON.parse(laundryIssueDetails);
        } catch (error) {
          console.error("Error parsing Laundry Issues data:", error);
          setLaundryIssuesError("Error parsing Laundry Issues data");
          return; // Exit the function early if there's an error
        }

        if (!Array.isArray(laundryIssuesData)) {
          console.error("Laundry Issues data is not an array");
          setLaundryIssuesError("Laundry Issues data is not an array");
          return; // Exit the function early if data is not an array
        }

        const laundryIssuesError = laundryIssuesData.map(
          (laundryIssues) => {
            if (
              !laundryIssues ||
              !laundryIssues.MstItemTypeId ||
              !laundryIssues.MstItemcategoryId ||
              !laundryIssues.MstItemId ||
              !laundryIssues.UOM ||
              !laundryIssues.Quantity ||
              !laundryIssues.Rate
            ) {
              return "Laundry Issues information is incomplete";
            }
            return null;
          }
        );

        hasLaundryIssueErrors = laundryIssuesError.some(
          (error) => error !== null
        );

        if (!hasLaundryIssueErrors) {
          setLaundryIssuesError("");
          hasLaundryIssueErrors = true;
        } else {
          setLaundryIssuesError(
            "Please provide complete Laundry Issues information"
          );
          hasLaundryIssueErrors = false;
        }
      }


      setLaundryIssuesFieldsError(isFormError);

      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );

      if (isFormValid && hasLaundryIssueErrors) {
        const payload = {

          txnLaundryIssuesId: txnLaundryIssuesId ? txnLaundryIssuesId : 0,
          mstClientId: parseInt(mstClientId),
          laundryIssueNo: laundryIssuesFields.issueNo,
          laundryIssueDate: laundryIssuesFields.date,
          mstLaundryCompanyId: laundryIssuesFields.issuedTo,
          laundryIssuedBy: laundryIssuesFields.issuedBy,
          laundryIssuesChild: laundryIssueDetails,
          remarks: laundryIssuesFields.remarks,
          createdBy: createdBy,
          flag: flag,
        };

        const response = await IUDAPI(payload, "LaundryIssueAPI/IUDLaundryIssues");
        if (flag === 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Laundry Issues Added Successfully 👍", {
              duration: 4000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error("Failed To Add Laundry Issues 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag === 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Laundry Issues Modified Successfully 👍", {
              duration: 4000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error("Failed To Modified Laundry Issues 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false)
        setIsLoading(false)
      }


    }
    else {
      const payload = {

        txnLaundryIssuesId: txnLaundryIssuesId ? txnLaundryIssuesId : 0,

        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(payload, "LaundryIssueAPI/IUDLaundryIssues");
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].Result === "D") {
          toast.success(`Laundry Issues data deleted successfully 🗑️`, {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        } else {
          toast.error(`Failed to delete Laundry Issues data 👎`, {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }


  };

  useEffect(() => {
    getLaundryIssueDatas();
    getLaundryCompaniesDatas();
    getItemTypeDatas();
    getItemCategoryDatas();
    getItemDatas();
  }, []);

  const getLaundryCompaniesDatas = async () => {
    try {
      const data = {
        mstClientId: parseInt(mstClientId, 10), // safer parse
      };

      const response = await BindPostAPI(
        data,
        "LaundryMasterAPI/BindLaundryCompany"
      );

      if (response?.data?.Table?.length > 0) {
        const getLaundryCompanies = response.data.Table.map((item) => ({
          value: item.MstLaundryCompanyId,
          label: item.LaundryCompany,
        }));
        setBindLaundryCompanies(getLaundryCompanies);
      } else {
        setBindLaundryCompanies([]);
      }
    } catch (error) {
      console.error("Error fetching laundry companies:", error);
      setBindLaundryCompanies([]); // fallback empty state
    }
  };


  const getItemTypeDatas = async () => {

    const response = await BindAPI("ItemsAPI/BindItemType");
    const getLaundryCompanies =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstItemTypeId,
          label: item.ItemType,
        }))
        : [];
    setBindItemType(getLaundryCompanies);
  };

  const getItemCategoryDatas = async () => {

    const data = {
      mstClientId: parseInt(mstClientId),
    };
    const response = await BindPostAPI(data, "ItemscategoryAPI/Binditemscategory");

    setBindItemCategory(response.data.Table);
  };

  const getItemDatas = async () => {

    const data = {
      mstClientId: parseInt(mstClientId),
    };
    const response = await BindPostAPI(data, "ItemsAPI/BindItems");

    setBindItem(response.data.Table);
  };

  const getLaundryIssueDatas = async () => {

    const data = {
      mstClientId: parseInt(mstClientId),
    };
    setIsLoading(true)
    const response = await BindPostAPI(data, "LaundryIssueAPI/BindLaundryIssues");

    setBindLaundryIssue(response.data.Table);
    setBindLaundryIssueChild(response.data.Table1);
     setIsLoading(false)
  };




  const handleEdit = (rowIndex) => {

    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setTxnLaundryIssuesId(bindLaundryIssue[rowIndex].TxnLaundryIssuesId);
    const currentDate = bindLaundryIssue[rowIndex].LaundryIssueDate;
    const formattedDate = currentDate.split("T")[0];
    setLaundryIssuesFields({
      issueNo: bindLaundryIssue[rowIndex].LaundryIssueNo,
      date: formattedDate,
      issuedTo: bindLaundryIssue[rowIndex].MstLaundryCompanyId,
      issuedBy: bindLaundryIssue[rowIndex].LaundryIssuedBy,
      remarks: bindLaundryIssue[rowIndex].Remarks,
    })

    const txnLaundryIssueId = bindLaundryIssue[rowIndex].TxnLaundryIssuesId;

    const laundryIssueData = Object.values(bindLaundryIssueChild).filter(
      (item) => {
        return String(item.TxnLaundryIssuesId) === String(txnLaundryIssueId);
      }
    );
    if (laundryIssueData.length === 0) {
      setTableData([
        {
          MstItemTypeId: "",
          MstItemcategoryId: "",
          MstItemId: "",
          UOM: "",
          Quantity: "",
          Rate: "",
          ItemcategoryList: [],
          ItemList: []
        },
      ]);
    } else {
      // Append the filtered data to your state using appendDataToState function
      appendDataToCommoditiesTable(JSON.stringify(laundryIssueData));
    }

  };

  const appendDataToCommoditiesTable = (newDataString) => {

    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {

      return {
        MstItemTypeId: data.MstItemTypeId,
        MstItemcategoryId: data.MstItemcategoryId,
        MstItemId: data.MstItemId,
        UOM: data.UOM,
        Quantity: data.Quantity,
        Rate: data.Rate,

      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData1(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);

  };
  useEffect(() => {

    updateTableData();
  }, [tableData]);
  const updateTableData = async () => {

    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData]; // Clone the current table data

      // Iterate through each row
      for (const row of updatedTableData) {
        if (row?.MstItemTypeId) {
          const getFilteredCategory = bindItemCategory
            .filter(
              (item) => item.MstItemTypeId === row.MstItemTypeId
            )
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.ItemcategoryList = getFilteredCategory;
        }

        if (row?.MstItemcategoryId) {
          const selectedCategory = bindItem
            .filter(
              (item) => item.MstItemCategoryId === row.MstItemcategoryId
            )
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.ItemList = selectedCategory;

          // Find the selected commodity for the row and set its unit of measure
          const selectedCommodity = selectedCategory.find(
            (item) => item.value === row.MstItemId
          );
          row.UOM = selectedCommodity?.uom || ""; // Reset if no selected commodity
        }

      }

      setTableData(updatedTableData);
    }
  };
  const updateTableData1 = async (formattedDataArray) => {

    if (JSON.stringify(previousTableData) !== JSON.stringify(formattedDataArray)) {
      const updatedTableData = [...formattedDataArray]; // Clone the current table data

      // Iterate through each row
      for (const row of updatedTableData) {
        if (row?.MstItemTypeId) {
          const getFilteredCategory = bindItemCategory
            .filter(
              (item) => item.MstItemTypeId === row.MstItemTypeId
            )
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.ItemcategoryList = getFilteredCategory;
        }

        if (row?.MstItemcategoryId) {
          const selectedCategory = bindItem
            .filter(
              (item) => item.MstItemCategoryId === row.MstItemcategoryId
            )
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.ItemList = selectedCategory;

          // Find the selected commodity for the row and set its unit of measure
          const selectedCommodity = selectedCategory.find(
            (item) => item.value === row.MstItemId
          );
          row.UOM = selectedCommodity?.uom || ""; // Reset if no selected commodity
        }

      }

      setTableData(updatedTableData);
    }
  };

  console.log("tableData", tableData)
  return (
    <div>
      <MainLayout pageName={"2"}>
       <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
        {visibleTable && (
          <GridPage
            title="Issues"
            header={LaundryIssueHeader}
            records={bindLaundryIssue}
            handleAction={handlePopup}
            handleEdit={handleEdit}
            blockView={true}
            showAdd={showAdd}
            onLaundryIssueView={showView}
          />
        )}
        {visibleAdd && (
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle
                  title="Issues"
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                />
              </div>
            </div>

            <div className={mainTable.mainContentScreen}>
              <form className=" p-5 min-h-[60vh] max-h-[72vh]">
                <div className={mainTable.grid4}>
                  <InputText
                    inputType="text"
                    title="Issue No"
                    name="issueNo"
                    classStar="text-red-500"
                    disabled={true}
                    content={laundryIssuesFields.issueNo}
                    // tabIndex="1"
                  />

                  <InputText
                    inputType="date"
                    title="Issue Date"
                    classStar="text-red-500"
                    name="date"
                    content={laundryIssuesFields.date}
                    controlFunc={(e) =>
                      setLaundryIssuesFields({
                        ...laundryIssuesFields,
                        date: e.target.value,
                      })
                    }
                    // tabIndex="1"
                  />

                  <DropDown
                    name="issuedTo"
                    title="Issued To"
                    classStar="text-red-500"
                    selectedOption={laundryIssuesFields.issuedTo}
                    options={bindLaundryCompanies}
                    controlFunc={(e) => {
                      setLaundryIssuesFields({
                        ...laundryIssuesFields,
                        issuedTo: e.target.value,
                      });
                    }}
                    controlFuncBlur={(e) => {
                      const value = e.target.value;
                      setLaundryIssuesFieldsError((prev) => ({
                        ...prev,
                        issuedToError: value
                          ? ""
                          : "Select Issued To",
                      }));
                    }}
                    placeholder="Select"
                    // tabIndex="1"
                    errorMessage={laundryIssuesFieldsError.issuedToError}
                  />


                  <InputText
                    inputType="text"
                    title="Issued By"
                    name="issuedBy"
                    content={laundryIssuesFields.issuedBy}
                    maxLength={100}
                    classStar="text-red-500"
                    controlFunc={(e) => {
                      {
                        const inputVal = e.target.value;
                        const onlyLettersRegex = /^[A-Za-z\s]*$/; // Allow letters, space, hyphen, apostrophe

                        if (onlyLettersRegex.test(inputVal)) {
                          setLaundryIssuesFields({
                            ...laundryIssuesFields,
                            issuedBy: e.target.value,
                          });
                        }
                      }
                    }}
                    controlFuncBlur={() => {
                      const trimmedBank =
                        laundryIssuesFields.issuedBy?.trim() || "";
                      setLaundryIssuesFieldsError(() => ({
                        ...laundryIssuesFieldsError,
                        issuedByError: trimmedBank ? "" : "Enter Issued By",
                      }));
                    }}
                    errorMessage={laundryIssuesFieldsError.issuedByError}
                  />

                </div>

                <table className="min-w-full border border-gray-300">
                  <thead className="bg-[#3D6643] text-white sticky top-0 z-10 ">
                    <tr>
                      <th className="border px-0.5 py-2 w-[20px]">S.No</th>
                      <th className="border px-4 py-2 w-[180px]">Item Type</th>
                      <th className="border px-4 py-2 w-[180px]">Category</th>
                      <th className="border px-4 py-2 w-[180px]">Name</th>
                      <th className="border px-4 py-2 w-[80px]">U.O.M</th>
                      <th className="border px-4 py-2 w-[80px]">Quantity</th>
                      <th className="border px-4 py-2 w-[80px]">Rate</th>
                      <th className="border px-4 py-2 w-[80px]">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index}>
                        <td className="border px-2 py-2 w-[30px]">
                          {index + 1}
                        </td>
                        <td className="border px-4 py-2">

                          <AutoDropDown
                            Class="Custom-class"
                            options={bindItemType}
                            placeholder="Select"
                            name="MstItemTypeId"
                            selectedOption={
                              row.MstItemTypeId
                                ? bindItemType.find(
                                  (x) => x.value == row.MstItemTypeId
                                )
                                : ""
                            }
                            controlFunc={(e) => {
                              handleInputChange(e, index, "MstItemTypeId");
                            }}
                          />
                        </td>

                        <td className=" border px-4 py-2">


                          <AutoDropDown
                            Class="Custom-class"
                            options={row.ItemcategoryList}
                            placeholder="Select"
                            name="MstItemcategoryId"
                            selectedOption={
                              row.MstItemcategoryId
                                ? row.ItemcategoryList.find(
                                  (x) => x.value == row.MstItemcategoryId
                                )
                                : ""
                            }
                            controlFunc={(e) => {
                              handleInputChange(e, index, "MstItemcategoryId");
                            }}
                          />

                        </td>

                        <td className="border px-4 py-2">

                          <AutoDropDown
                            Class="Custom-class"
                            options={row.ItemList}
                            placeholder="Select"
                            name="MstItemId"
                            selectedOption={
                              row.MstItemId
                                ? row.ItemList.find(
                                  (x) => x.value == row.MstItemId
                                )
                                : ""
                            }
                            controlFunc={(e) => {
                              handleInputChange(e, index, "MstItemId");
                            }}
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.UOM}
                            maxLength={10}
                            disabled={true}
                            controlFunc={(e) => {
                              const InputText = e.target.value;

                              if (/^[A-Za-z]*$/.test(InputText)) {
                                handleInputChange(e.target, index, "UOM");
                              }
                            }}
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.Quantity}
                            maxLength={5}
                            controlFunc={(e) => {
                              const InputText = e.target.value;

                              if (/^\d+$/.test(InputText)) {
                                handleInputChange(e.target, index, "Quantity");
                              }
                            }}
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <InputText
                            type="text"
                            content={row.Rate}
                            maxLength={7}
                            controlFunc={(e) => {
                              const InputText = e.target.value;

                              if (/^\d*\.?\d*$/.test(InputText)) {
                                handleInputChange(e.target, index, "Rate");
                              }
                            }}
                          />
                        </td>

                        <td className="border px-4 py-2">
                          <div className="flex gap-4 items-center justify-center">
                            <svg
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="w-6 h-6 text-black cursor-pointer"
                              onClick={() => handleDeleteRow(index)}
                            >
                              <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                            </svg>
                            {index === tableData.length - 1 &&
                              tableData.length < 4 && (
                                <svg
                                  viewBox="0 0 1024 1024"
                                  fill="currentColor"
                                  onClick={handleAddRow}
                                  className="w-6 h-6 text-black cursor-pointer"
                                >
                                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                                </svg>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="hidden md:block">
                  {laundryIssuesError && (
                    <div className="text-red-500">{laundryIssuesError}</div>
                  )}
                </div>
                <br />

                <div>
                  <TextArea
                    title="Remarks"
                    name="remarks"
                    placeholder="Remarks"
                    // tabIndex="1"
                    maxLength={500}
                    rows={4}
                    content={laundryIssuesFields.remarks}
                    controlFunc={(e) => {
                      setLaundryIssuesFields({
                        ...laundryIssuesFields,
                        remarks: e.target.value,
                      });
                    }}
                  />
                </div>

                <div className="col-span-2 flex justify-center mt-6 gap-4">
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled}
                  />
                </div>
              </form>
            </div>
          </div>
        )}
        <MainPopup
          popUpOpen={popUpOpen}
          setpopUpOpen={setpopUpOpen}
          Open={showView}
        >
          <div>
            <PopUpScreenTitle
              title="Issues"
              setpopUpOpen={setpopUpOpen}
              hederDetails={true}
            />

            <LaundryIssuePopup data={viewPopupData} data1={viewPopupChildData} />
          </div>

        </MainPopup>

        <MainPopup
          popUpOpen={popUpOpen1}
          setpopUpOpen={setpopUpOpen1}
          Open={handlePopup}
        >
          <div>
            <PopUpScreenTitle
              title="Issues"
              setpopUpOpen={setpopUpOpen1}
              hederDetails={true}
            />

            <LaundryIssues data={viewPopupData1} data1={viewPopupChildData1} />
          </div>
          <PopUpButtons
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            viewDetails={viewDetails}
            handleSubmit={handleSubmit}
            cancel={cancel}
            disabledBtn={submitBtnDisabled ? true : false}
          />
        </MainPopup>

      </MainLayout>
    </div>
  );
};

export default LaundryIssue;
